import { render, staticRenderFns } from "./workspace-feeds.vue?vue&type=template&id=2512c9ce&scoped=true"
import script from "./workspace-feeds.vue?vue&type=script&lang=js"
export * from "./workspace-feeds.vue?vue&type=script&lang=js"
import style0 from "./workspace-feeds.vue?vue&type=style&index=0&id=2512c9ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2512c9ce",
  null
  
)

export default component.exports